<template>
    <div
        class="kpi-bar-chart d-flex align-end"
        style="height:48px;gap:4px;width:100%"
    >
        <div
            v-for="(bar, i) in normalized"
            :key="i"
            :style="{
                width: '100%',
                height: `${bar.height}%`,
                backgroundColor: bar.highlight ? 'var(--color-primary)' : `rgba(112, 42, 225, ${bar.opacity})`,
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                boxShadow: bar.highlight ? '0 0 10px rgba(112,42,229,.25)' : 'none',
                transition: 'all 300ms',
            }"
        />
    </div>
</template>

<script>
export default {
    name: 'KpiBarChart',
    props: {
        values: {
            type: Array,
            default: () => [30, 45, 60, 50, 85, 65, 75],
        },
        highlightIndex: {
            type: Number,
            default: 4,
        },
    },
    computed: {
        normalized() {
            const max = Math.max(...this.values, 1)
            return this.values.map((v, i) => ({
                height: Math.max(8, Math.round((v / max) * 100)),
                opacity: 0.1 + (v / max) * 0.4,
                highlight: i === this.highlightIndex,
            }))
        },
    },
}
</script>
